import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { CATEGORIES } from "@/mocks/archive";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dagkgl1tto0ceqqnhu2g";

export default function SiteFooter() {
  const [state, setState] = useState<"idle" | "loading" | "done">("idle");
  const [msg, setMsg] = useState("");

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = String(fd.get("mobile_alt") || "").trim();
    if (honeypot) {
      setState("done");
      setMsg("感谢订阅，最新黑料简报将发送至你的邮箱。");
      form.reset();
      return;
    }
    fd.delete("mobile_alt");
    setState("loading");
    setMsg("");
    try {
      const res = await fetch(SUBMIT_ADDR, { method: "POST", body: new URLSearchParams(fd as unknown as Record<string, string>) });
      const text = await res.text();
      let parsed: any = null;
      try { parsed = JSON.parse(text); } catch { parsed = null; }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text || "";
      if (res.ok && (parsed?.code === "OK" || !parsed) && !/spam|form data is spam/i.test(String(serverMsg))) {
        setState("done");
        setMsg("订阅成功！最新娱乐黑料简报会定期推送到你的邮箱。");
        form.reset();
      } else {
        setState("idle");
        setMsg(String(serverMsg && serverMsg !== text ? serverMsg : (parsed?.meta?.detail || "订阅失败，请稍后再试。")));
      }
    } catch {
      setState("idle");
      setMsg("网络异常，订阅未能送达，请稍后重试。");
    }
  }

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 pt-12 md:pt-16 pb-8">
        <div className="grid gap-10 lg:grid-cols-[1.3fr_1fr_1fr_1.4fr] md:grid-cols-2">
          {/* 品牌 */}
          <div>
            <div className="flex items-center gap-2.5">
              <span className="grid place-items-center w-9 h-9 rounded-lg bg-background-50 text-primary-700">
                <i className="ri-focus-3-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">黑料档案 · 八卦志</span>
            </div>
            <p className="mt-4 text-sm leading-7 text-primary-100/90">
              明星黑料分类档案库，把人品争议、感情纠纷、耍大牌、违约失信、言论翻车、行为失当等争议分门别类整理，系统梳理艺人塌房全过程，让每一次吃瓜都有章可循。
            </p>
            <p className="mt-5 text-xs leading-6 text-primary-200/70">
              内容仅作娱乐信息梳理与舆情观察，最终事实以权威司法与品牌官方渠道披露为准。
            </p>
          </div>

          {/* 栏目 */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 tracking-wide">分类栏目</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {CATEGORIES.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/archive?cat=${c.slug}`}
                    className="inline-flex items-center gap-2 text-primary-100/90 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    <i className={`${c.icon} text-xs text-accent-400`} />
                    {c.name}黑料
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 指南 */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 tracking-wide">读者指南</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/#process" className="text-primary-100/90 hover:text-background-50 transition-colors whitespace-nowrap">塌房全过程拆解</Link></li>
              <li><Link to="/archive" className="text-primary-100/90 hover:text-background-50 transition-colors whitespace-nowrap">全部分类档案</Link></li>
              <li><Link to="/about#principles" className="text-primary-100/90 hover:text-background-50 transition-colors whitespace-nowrap">编辑与内容原则</Link></li>
              <li><Link to="/about#submit" className="text-primary-100/90 hover:text-background-50 transition-colors whitespace-nowrap">提交线索与爆料</Link></li>
              <li><Link to="/#faq" className="text-primary-100/90 hover:text-background-50 transition-colors whitespace-nowrap">常见问题</Link></li>
            </ul>
          </div>

          {/* 订阅 */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 tracking-wide">每周黑料简报</h4>
            <p className="mt-3 text-sm leading-6 text-primary-100/80">
              订阅后每周汇总全网高热吃瓜事件与分类更新，不错过任何瓜田信号。
            </p>
            <form data-readdy-form="黑料档案读者订阅" onSubmit={onSubmit} className="mt-4 space-y-3">
              <div className="flex flex-col sm:flex-row gap-2">
                <label htmlFor="nl-email" className="sr-only">邮箱地址</label>
                <input
                  id="nl-email"
                  name="email"
                  type="email"
                  required
                  placeholder="输入邮箱地址"
                  className="w-full rounded-md bg-primary-900/70 border border-primary-800 px-3.5 py-2.5 text-sm text-background-50 placeholder:text-primary-300/60 outline-none focus:ring-2 focus:ring-accent-400"
                />
                <button
                  type="submit"
                  disabled={state === "loading"}
                  className="shrink-0 inline-flex items-center justify-center gap-1.5 rounded-md bg-accent-500 text-primary-950 hover:bg-accent-400 px-4 py-2.5 text-sm font-semibold transition-colors whitespace-nowrap disabled:opacity-70"
                >
                  {state === "loading" ? "发送中…" : "订阅简报"}
                  {state !== "loading" && <i className="ri-send-plane-line text-sm" />}
                </button>
              </div>
              <input
                name="mobile_alt"
                type="text"
                className="input-protection"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
            </form>
            {msg && (
              <p className="mt-3 text-xs text-accent-200" role="status">
                <i className="ri-information-line mr-1" />
                {msg}
              </p>
            )}
            <p className="mt-3 text-[11px] text-primary-200/60">放心，你的邮箱仅用于接收简报，不会被分享给第三方。</p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-900 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-200/70">
          <p>© 2026 黑料档案 · 明星黑料分类档案盘点。本站内容仅供娱乐信息梳理。</p>
          <div className="flex items-center gap-5">
            <a href="#/" rel="nofollow" className="hover:text-background-50 transition-colors whitespace-nowrap">隐私说明</a>
            <a href="#/" rel="nofollow" className="hover:text-background-50 transition-colors whitespace-nowrap">免责声明</a>
            <Link to="/about" className="hover:text-background-50 transition-colors whitespace-nowrap">关于我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}